export enum EFeatureFlags {
  MAINTENANCE_MODE = 'maintenance_mode',
  UMY_VOICE_SESSION = 'voice_agent'
}
